import { GoBackHeaderTitle } from "components";
import { t } from "i18next";
import { ContentLayout } from "layouts";
import { ProductPriceInsight } from "modules/insights";
import { useLocation, useNavigate } from "react-router-dom";

const ProductPriceInsightPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <ContentLayout
      title={
        <GoBackHeaderTitle
          title={t("Price Insight")}
          onGoBack={() =>
            navigate({
              pathname: "/insights/price-insights",
              search: state?.productsListSearch
            })
          }
        />
      }
    >
      <ProductPriceInsight />
    </ContentLayout>
  );
};

export default ProductPriceInsightPage;
